@if (canCancelRequestValidation) {
  <button
    mat-icon-button
    (click)="cancelRequestValidation()"
    matTooltip="Annuler la demande de validation et retourner en brouillon"
  >
    <mat-icon class="stroke stroke-reverse error">playlist_add_check</mat-icon>
  </button>
}
